import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import styles from './style';

import authFunc from '../../utils/auth';

import Loading from '../../Components/Loading';

import {
  Table,
  TableRow,
  TableRowColumn,
  TableHeaderRow,
  Pagination,
  Container,
  Button
} from '../../Components';

import filter from '../../utils/filter';

export default class TablePart extends Component {
  componentDidMount() {
    this.search = this.page.search;
  }
  getRuleArray(auth, crule, key) {
    if (!key) {
      return false;
    }
    this.auth = auth;
    let arr = [];
    for (let i = 0; i <= crule.length; i++) {
      if (key === crule[i].value) {
        // console.log(crule[i].rule);
        arr = crule[i].rule;
        break;
      }
    }
    if (arr.indexOf(auth) < 0) {
      return false; // 该操作不在权限内
    }
    return true; // 该操作在权限内
  }
  genHeader() {
    const { itemFormat, operations } = this.props;
    const opLength =
      operations.filter(item => !item.auth || authFunc(item.auth)).length;

    const opWidth = opLength * styles.opBtnLength;
    return (
      <TableHeaderRow>
        {
          itemFormat.map((item, idx) => {
            const key = `${item.title}-${idx}`;
            return (
              <TableRowColumn
                key={key}
                columnNumber={idx}
                title={item.title}
              >{item.title}</TableRowColumn>
            );
          })
        }
        {
          opLength ?
            <TableRowColumn style={{ width: opWidth }}>
              操作
            </TableRowColumn>
          :
            ''
        }
      </TableHeaderRow>
    );
  }
  genOperations(rowIdx, item) {
    const { operations, items, operationsRule } = this.props;
    const relyKey = item[operationsRule.relyKey];
    const crule = operationsRule.crule;
    // console.log(operationsRule.crule, item[operationsRule.relyKey]);

    const map = {
      add: '新增',
      delete: '删除',
      dateil: '查看',
      update: '编辑',
    };

    return (
      <TableRowColumn>
        {
          operations.map((op) => {
            if (op.auth && !authFunc(op.auth)) {
              return null;
            }
            // console.log(this.getRuleArray(op.auth, crule, relyKey))
            if (!this.getRuleArray(op.auth, crule, relyKey)) {
              return null;
            }
            if (op.type) {
              const func = () => {
                if (op.url) {
                  console.log(`跳转${op.url}`);
                } else {
                  op.func(rowIdx, items[rowIdx]);
                }
              };
              return (
                <Button
                  key={`${rowIdx}-${op.type}`}
                  style={styles.opBtn}
                  text={map[op.type]}
                  onClick={func}
                  idx={rowIdx}
                  type={['primary', 'small']}
                />
              );
            }

            const func = () => {
              op.func(rowIdx, items[rowIdx]);
            };
            return (
              <Button
                key={`${rowIdx}-${op.text}`}
                text={op.text}
                onClick={func}
                style={styles.opBtn}
                type={['primary', 'small']}
              />
            );
          })
        }
      </TableRowColumn>
    );
  }
  genRows() {
    const { items, itemFormat } = this.props;

    if (!items.length) {
      return (
        <TableRow rowNumber={0}>
          <TableRowColumn columnNumber={0}>
            列表为空
          </TableRowColumn>
        </TableRow>
      );
    }

    return items.map((item, rowIdx) => {
      const rowKey = `rowKey${rowIdx}`;

      return (
        <TableRow
          key={rowKey}
          rowNumber={rowIdx}
        >
          {
            itemFormat.map((config, colIdx) => {
              const { format, key } = config;
              const value = format ? filter(format, item[key]) : item[key];

              return (
                <TableRowColumn
                  key={key}
                  columnNumber={colIdx}
                  title={value}
                >{value}</TableRowColumn>
              );
            })
          }
          {
            this.genOperations(rowIdx, item)
          }
        </TableRow>
      );
    });
  }
  render() {
    const {
      isLoading,
      title, minWidth,
      beforeSearch,
      success,
      searchParams,
      url,
    } = this.props;

    return (
      <div>
        {
          <Container
            title={title}
          >
            {
              isLoading ?
                <Loading />
              :
                <Table hoverable center style={minWidth ? { minWidth } : {}} >
                  {this.genHeader()}
                  {this.genRows()}
                </Table>
            }
            <Pagination
              url={url}
              beforeSearch={beforeSearch}
              success={success}
              searchParams={searchParams}
              style={{
                margin: '15px 0'
              }}
              ref={(item) => {
                this.page = item;
              }}
            />
          </Container>
        }

      </div>
    );
  }
}

TablePart.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  itemFormat: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  operations: PropTypes.arrayOf(PropTypes.shape()),
  operationsRule: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool,
  minWidth: PropTypes.number,
  beforeSearch: PropTypes.func,
  success: PropTypes.func,
  searchParams: PropTypes.shape(),
};

TablePart.defaultProps = {
  title: '查询结果',
  isLoading: false,
  operations: [],
  operationsRule: [],
  minWidth: null,
  success: () => {},
  beforeSearch: () => {},
  searchParams: {},
};



// WEBPACK FOOTER //
// ./src/Parts/TablePart/index.js